// Core components
import { Component, OnInit } from '@angular/core';

/**
 * Footer component
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  public currentYear: number = new Date().getFullYear();

  /**
   * Life cycle method
   */
  constructor() { }

  /**
   * Life cycle init method
   */
  ngOnInit() {
  }

}
